import * as actionTypes from './actionsType';

export const getAllDepartments = (res) => ({
    type: actionTypes.GET_ALL_DEPARTMENTS,
    result: res,
});
